import { http } from '../config/config-receituario'

export default {
    listar: async (token) => {
        return http.get('webhooks', {
            headers: {
                'Authorization': token
            }
        })
    },
    salvar: (token, webhook) => {
        return http.post('webhooks', webhook, {
            headers: {
                'Authorization': token
            }
        })
    },
    deletar: (token, id) => {
        return http.delete(`webhooks/${id}`, {
            headers: {
                'Authorization': token
            }
        })
    },
    update: (token, webhook) => {
        return http.put(`webhooks/${configuracao.id}`, webhook, {
            headers: {
                'Authorization': token
            }
        })
    }

}